/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { ToastOptions, ToastPosition, toast } from "react-toastify";

import { ONE_SECOND } from "@vienna/common";

import { ConditionalWrapper } from "src/components/UI/ConditionalWrapper";
import { StyledLink } from "src/components/UI/Links";

export class Toaster {
  private static defaultOptions: ToastOptions = {
    position: "bottom-right" as ToastPosition,
    autoClose: 3 * ONE_SECOND,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  public static success(message: string, link?: string): void {
    toast(
      () => (
        <ConditionalWrapper
          condition={!!link}
          wrapper={(children: React.ReactNode) => <StyledLink href={link}>{children}</StyledLink>}
        >
          <span>{message}</span>
        </ConditionalWrapper>
      ),
      this.defaultOptions
    );
  }

  public static error(message: string): void {
    toast.error(message, this.defaultOptions);
  }
}
